import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/services/auth.guard';
import { AdminGuard } from './admin/guards/admin.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { TemplateGeneralComponent } from './home/pages/template-general/template-general.component';
import { RoleRedirectHomeGuard } from './shared/services/role-redirect-home.guard';

@Component({
  selector: 'app-placeholder',
  template: ''
})
export class RoleRedirectComponent { }

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canLoad: [AdminGuard],
    canActivate: [AdminGuard]
  },
  {
    path: '404',
    component: TemplateGeneralComponent,
    children: [
      {
        path: '', component: NotFoundComponent,
        canActivate: [AuthGuard],
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'redirect'
  },
  {
    path: 'redirect',
    canActivate: [RoleRedirectHomeGuard],
    component: RoleRedirectComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
